import { styled, TableCell } from "@mui/material";

type Props = {
  title: string;
  value: string;
};

export const InformationTd = styled(TableCell)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

function InformationRow({ title, value }: Props) {
  return (
    <tr>
      <InformationTd> {title} </InformationTd>
      <InformationTd>{value}</InformationTd>
    </tr>
  );
}

export default InformationRow;
